import { nanoid } from 'nanoid';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { objectsOfValueTransaction } from '@monestry-dev/schema';
import { postData } from '../../../../redux/reducers/data';
import { setMessage } from '../../../../redux/actions/message';
import { handleValidateAndDispatchAccount, handleConnectedDepositMode, maybeTriggerSync } from '../submitUtils';

dayjs.extend(utc);

export default async function handleUnlistedSharesSubmit({ formValues, dispatch, setLoading, category }) {
  const flattened = await handleConnectedDepositMode({ ...formValues }, { dispatch });
  const { resultDispatch, payload } = await handleValidateAndDispatchAccount({ category, userInput: flattened, dispatch, setLoading });
  const accountId = resultDispatch?.payload?.accounts?.[0]?.id;

  if (accountId) {
    try {
      const dataArray = [
        objectsOfValueTransaction.cast({
          id: nanoid(),
          accountId,
          assetId: accountId,
          date: dayjs.utc(flattened.date).startOf('day').valueOf(),
          category: 'unlistedShares',
          quantity: flattened.quantity,
          upac: flattened.upac / flattened.quantity,
          upbc: flattened.upbc / flattened.quantity,
          uptc: null,
          transactionCurrency: null,
          accountCurrency: flattened.currency,
          assetCurrency: flattened.currency,
          importFlag: 'post',
          description: 'Initial',
        }),
      ];
      await dispatch(postData({ data: dataArray, category: 'unlistedShares', accountId }));
    } catch (error) {
      setLoading(false);
      dispatch(setMessage('addTransactionManually'));
    }
    maybeTriggerSync({ payload, category, dispatch, accountId });
  }
}
